import type { IconProps } from './IconProps';

export const PieChartIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M14.14 10.593A6.667 6.667 0 1 1 5.333 1.887M14.667 8A6.667 6.667 0 0 0 8 1.333V8z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
